/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-09-10 10:48:44
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ReactTypeformEmbed } from 'react-typeform-embed';
import { TYPEFORM_SURVEY } from 'src/constants/typeform-survey';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = WithI18nProps;

class TypeFormEmbededFeedback extends Component<Props> {
  componentWillReceiveProps(nextProps: Props) {
    const { conditionShow = false, conditionShowStateChange = false } = this.props;
    const {
      conditionShow: nextConditionShow = false,
      conditionShowStateChange: nextConditionShowStateChange = false
    } = nextProps;

    if (
      (!conditionShow && nextConditionShow) ||
      conditionShowStateChange !== nextConditionShowStateChange
    ) {
      this.openForm();
    }
  }

  render() {
    const { type, email, tenantId, i18n, onSubmit } = this.props;
    const { link, mode } = TYPEFORM_SURVEY[type];
    const linkWithInfo = `${link}?tenant=${tenantId}&email=${email}`;

    return (
      <div>
        <ReactTypeformEmbed
          popup
          mode={mode}
          autoOpen={false}
          url={linkWithInfo}
          hideHeaders
          hideFooter
          buttonText={i18n.translate('AdminHTML.Common.Action.go')}
          style={{ width: 0, height: 0 }}
          opacity={50}
          ref={tf => {
            this.typeformEmbed = tf;
          }}
          onSubmit={onSubmit}
        />
      </div>
    );
  }

  // Call to open form survey
  openForm = () => {
    this.typeformEmbed.typeform.open();
  };
}

const mapStateToProps = (state, props) => {
  return {
    email: _.get(state.oauth.tenantApp, 'externalInfo.email'),
    tenantId: _.get(state.oauth.tenantApp, 'tenantId')
  };
};

export default connect(mapStateToProps)(withI18n()(TypeFormEmbededFeedback));
